import { useQuery } from 'react-query';
import { getFieldsOperations } from '../api/get-fields-operations';
import { ViewOptions } from '../components/ViewOptionsDropdown/view-options-dropdown.constants';

const CACHE_TIME = 60 * 1000; // one minute
const QUERY_RETRIES = 2;

export const useOperationsCount = ({ orgId }: { orgId: string }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ['operations-count', orgId],
    queryFn: () =>
      getFieldsOperations({
        orgId,
        excludeSourceGeometry: true,
        viewOption: ViewOptions.SINGLE_OPERATION,
      }),
    staleTime: CACHE_TIME,
    retry: QUERY_RETRIES,
    enabled: Boolean(orgId),
  });

  return {
    count: data?.data.pagination.total_count,
    isLoading,
    isFetching,
    error,
  };
};
